@if (message()) {
  <div
    class="bo-auth-banner"
    [class.bo-auth-banner--error]="variant() === 'error'"
    [class.bo-auth-banner--info]="variant() === 'info'"
    [class.bo-auth-banner--success]="variant() === 'success'"
    [attr.role]="variant() === 'error' ? 'alert' : undefined"
    [attr.aria-live]="variant() !== 'error' ? 'polite' : undefined"
  >
    <span class="bo-auth-banner__icon" aria-hidden="true">
      @switch (variant()) {
        @case ('error') {
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"/>
            <line x1="15" y1="9" x2="9" y2="15"/>
            <line x1="9" y1="9" x2="15" y2="15"/>
          </svg>
        }
        @case ('success') {
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"/>
            <path d="M9 12l2 2 4-4"/>
          </svg>
        }
        @default {
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"/>
            <line x1="12" y1="16" x2="12" y2="12"/>
            <line x1="12" y1="8" x2="12.01" y2="8"/>
          </svg>
        }
      }
    </span>
    <span class="bo-auth-banner__message">{{ message() }}</span>
  </div>
}
